module.exports = __webpack_public_path__ + "img/faq-accordion-up.839ed6f8.svg";